<template>
  <div class="device-detail-log-main">
    <!-- 搜索排序 -->
    <div class="device-detail-log-action">
      <div class="device-detail-log-action-row1">
        <ul class="device-detail-log-search">
          <li>
            <a-input
              :placeholder="$t('com_form_device_param_name_placeholder')"
              v-model="alarmNameParam"
              @pressEnter="getData"
              @change="
                () => {
                  if (!alarmNameParam) {
                    this.getData();
                  }
                }
              "
              allowClear
            />
          </li>
          <li>
            <a-range-picker
              @change="
                value => {
                  this.dateParam = value;
                  this.getData();
                }
              "
              v-model="dateParam"
            />
          </li>
          <li>
            <a-button type="primary" @click="getData">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  this.dateParam = null;
                  this.alarmNameParam = '';
                  this.faultLevelParam = [];
                  this.paramPagination.current = 1;

                  // 重新获取数据
                  this.getData();
                }
              "
            >
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>
      </div>
    </div>

    <!-- 内容 -->
    <div class="device-detail-log-content">
      <div class="device-detail-tab-conent g-table">
        <a-table
          :columns="paramColumns"
          :data-source="paramDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleParamTable"
          :loading="loading"
        >
          <!-- 类型 -->
          <template slot="operationType" slot-scope="text">
            <span>{{ $t('device_control_log_type')[text] }}</span>
          </template>

          <!-- 执行数据 -->
          <template slot="executeData" slot-scope="text, record">
            <div class="g-table-text">
              <a-icon
                type="copy"
                data-clipboard-action="copy"
                title="Copy"
                style="color:#ccc"
                :data-clipboard-text="`${text}`"
                :id="`logs_device_operation_event_${record.id}`"
                @click="copyContent(`#logs_device_operation_event_${record.id}`)"
                v-if="text"
              />{{ text || '' }}
            </div>
          </template>

          <!-- executeStartTime -->
          <template slot="executeStartTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- executeStartTime -->
          <template slot="executeEndTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- operationType -->
          <template slot="executeResult" slot-scope="text">
            <!-- 执行结果，0-执行失败，1-执行成功，2-执行超时 -->
            <span v-if="text === 0">{{ $t('com_msg_fail') }}</span>
            <span v-else-if="text === 1">{{ $t('com_msg_success') }}</span>
            <span v-else-if="text === 2">{{ $t('com_msg_timeout') }}</span>
          </template>
        </a-table>

        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="paramPagination.current"
            :total="paramPagination.total"
            :pageSize.sync="paramPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { DeviceParamsRecord } from '@/api/device';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import { trim } from '@/libs/utils';

export default {
  mixins: [deviceAuth],
  props: {
    // 设备id
    deviceId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),

    // 操作类型
    hasControlTypes() {
      return this.deviceControlType && this.deviceControlType.length > 0;
    },
  },
  data() {
    return {
      trim,
      loading: false,
      // 参数数据
      paramDataList: null,

      // 操作列表
      // id:"主键",
      // operationType:"更新类型，0-新建，1-编辑，2-删除，3-禁用，4-重新启用",
      // executeUser:"操作的用户ID",
      // executeUserName:"操作的用户名",
      // executeStartTime:"执行开始时间，long 类型",
      // executeEndTime:"执行结束时间，long 类型",
      // executeData:"记录执行的操作内容（编辑的内容原始json字符串）",
      // executeResult:"执行结果，0-执行失败，1-执行成功，2-执行超时",
      // hostIp:"获取的用户登录ip地址",
      // location:"该ip所在地"
      paramColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },

        {
          title: this.$t('logs_table_params_data'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_user'),
          dataIndex: 'executeUserName',
          align: 'center',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
          align: 'center',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          align: 'center',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_config_start_time'),
          dataIndex: 'executeStartTime',
          scopedSlots: { customRender: 'executeStartTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_config_end_time'),
          dataIndex: 'executeEndTime',
          scopedSlots: { customRender: 'executeEndTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_execute_end_result'),
          dataIndex: 'executeResult',
          scopedSlots: { customRender: 'executeResult' },
        },
      ],

      // 配置记录搜索参数
      dateParam: null,
      deviceNameParam: '',
      alarmNameParam: '',
      faultCodeParam: '',

      paramPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序
        orderField: 3,
        orderType: 1,
      },
    };
  },

  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      this.getParamList();
    },

    // 获取配置日志
    getParamList(params) {
      // devId:"设备ID，必填",
      // keyword:"查询关键字，针对设备名称或SN查询",
      // date:"执行时间范围查询，默认不传，格式为起始时间-结束时间，例如：1657637444600-1657637554659",
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const _params = {
        devId: this.deviceId,
        pageNo: this.paramPagination.current,
        pageSize: this.paramPagination.pageSize,
        keyword: this.trim(this.alarmNameParam) || undefined,
        date:
          this.dateParam && this.dateParam.length === 2
            ? `${this.dateParam[0].startOf('day').valueOf()}-${this.dateParam[1]
                .endOf('day')
                .valueOf()}`
            : undefined,
        orderField: this.paramPagination.orderField,
        orderType: this.paramPagination.orderType,
        ...(params || {}),
      };

      this.loading = true;
      DeviceParamsRecord(_params)
        .then(res => {
          if (res.code === 0) {
            this.paramDataList = res.data || [];

            this.paramPagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页
    currentPageChange(page) {
      this.paramPagination.current = page;

      // 重新获取数据
      this.getData();
    },

    handleParamTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;
      console.log('field', field);

      if (field === 'id') {
        orderField = 0;
      } else if (field === 'operationType') {
        orderField = 1;
      } else if (field === 'executeUser') {
        orderField = 2;
      } else if (field === 'executeStartTime') {
        orderField = 3;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.paramPagination.orderField = orderField;
      this.paramPagination.orderType = orderType;

      this.getParamList({
        orderField,
        orderType,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.device-detail-log-main {
  display: flex;
  flex-direction: column;
  flex: 1;

  // 搜索
  .device-detail-log-action {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    background: #fff;
    margin-bottom: 16px;

    .device-detail-tab {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      gap: 24px;
      margin-bottom: 16px;
      li {
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        display: flex;

        &.active {
          color: @primary-color;
          font-weight: 600;
          position: relative;

          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: @primary-color;
            position: absolute;
            bottom: -4px;
            left: 0;
          }
        }
      }
    }

    .device-detail-log-action-row1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      // 搜索排序
      ul.device-detail-log-search {
        display: flex;
        margin: 0;
        padding: 0;
        list-style: none;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        li {
          display: flex;
          align-items: center;
          width: 350px;
          gap: 12px;
          &:last-child {
            width: auto;
          }
        }
      }

      // 排序
      .device-detail-log-btn {
        display: flex;
        align-items: center;

        button {
          margin-left: 12px;
        }
      }
    }

    .device-detail-log-action-row2 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 24px 0 0 0;
      span {
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        margin-right: 16px;
      }
    }
  }

  // 内容
  .device-detail-log-content {
    background: #fff;
    flex: 1;
    display: flex;

    .device-detail-tab-conent {
      width: 100%;
    }
  }
}
</style>
